import styled, { css } from 'styled-components';

export const UnfinishedTestCaseExecutionsStyled = styled.div`
  margin: 16px;
`;

export const TableHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  min-height: 28px;
`;

export const ToggleStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TableStyled = styled.div<{ displayBottomBorder?: boolean }>`
  ${({ displayBottomBorder }) => {
    return (
      displayBottomBorder &&
      css`
        border-bottom: 2px solid var(--ds-border, var(--ds-fb-border));
      `
    );
  }}
`;

export const TooltipWrapperStyled = styled.div`
  min-width: 0;
`;

export const QAlityPaginationStyled = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 32px;
`;

export const CheckCircleIconStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-bottom: 32px;

  svg {
    width: 120px;
    height: 120px;
    var(--ds-text-subtlest, var(--ds-fb-text-subtlest));
  }

  span {
    margin-top: 32px;
    font-size: 24px;
  }
`;

export const SpinnerStyled = styled.div`
  padding: 32px;
`;

export const NoTestCycleStyled = styled.i`
  color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));
  cursor: text;
`;
